/**
 * tanblock 支付相关
 */
import apis from 'src/const/apis';
import request from 'src/utils/request';

export default {
  namespaced: true,
  state: {
    exclude_app_package_id: '',
    blockedAppList: [],
  },
  mutations: {
    setAppid(state, data) {
      state.exclude_app_package_id = data;
    },
    setBlockedAppList(state, data) {
      state.blockedAppList = data;
    },
  },
  actions: {
    tanCreate(store, data) {
      return request.post(apis.tanblock.create, data);
    },
    async tanGetList({ commit }) {
      try {
        const resp = await request.get(apis.tanblock.list);
        const { app_list } = resp.data;
        commit('setBlockedAppList', app_list);

        return resp;
      } catch (error) {
        commit('setBlockedAppList', []);

        throw error;
      }
    },
    tanDelete(store, data) {
      return request.delete(apis.tanblock.delete, data);
    },
    tanUpdate(store, data) {
      return request.post(apis.tanblock.update, data);
    },
    async tanGetId({ commit }) {
      try {
        const { data } = await request.get(apis.tanblock.idCode);
        const { blocked_app_id = '' } = data;
        commit('setAppid', blocked_app_id);
      } catch (error) {
        commit('setAppid', '');
      }
    },
  },
};
